// A fixed add-on (snippets/fixed-addon.liquid), on the product page and on a cart line.
// "+" shows the types and chooses the first in stock; a tile changes the choice; "Skjul" goes back to the "+" row.
// Product page: "Læg i kurv" adds one of the chosen type with the product (cart.js). Cart: "Tilføj" adds one.
// The tiles are a radio group: one Tab stop (the chosen tile), arrow keys move the choice.
class FixedAddon extends HTMLElement {
  connectedCallback() {
    this.offer = this.querySelector(".fixed-addon__offer");
    this.chosen = this.querySelector(".fixed-addon__chosen");
    this.tiles = [...this.querySelectorAll("[data-addon-variant]")];
    this.name = this.querySelector("[data-addon-name]");
    this.price = this.querySelector(".fixed-addon__price");
    this.confirm = this.querySelector("[data-addon-confirm]");
    this.confirmPrice = this.querySelector("[data-addon-confirm-price]");
    this.pickLabel = this.name.textContent;
    this.tiles.forEach((t) => (t.dataset.out = t.disabled ? "1" : ""));
    this.roving();

    this.querySelector("[data-addon-add]").addEventListener("click", () => {
      this.open(true);
      this.pick(this.inStock()[0]);
      this.picked?.focus({ preventScroll: true });
    });
    this.querySelector("[data-addon-remove]").addEventListener("click", () => {
      this.pick(null);
      this.open(false);
      this.querySelector("[data-addon-add]").focus({ preventScroll: true });
    });
    this.tiles.forEach((tile) => {
      tile.addEventListener("click", () => this.pick(tile));
      tile.addEventListener("keydown", (event) => this.onKey(event, tile));
    });
    this.confirm?.addEventListener("click", () => this.picked && this.addToCart(this.picked));
  }

  inStock() {
    return this.tiles.filter((t) => !t.dataset.out);
  }

  open(isOpen) {
    this.offer.hidden = isOpen;
    this.chosen.hidden = !isOpen;
  }

  pick(tile) {
    this.picked = tile || null;
    this.tiles.forEach((t) => t.setAttribute("aria-checked", t === tile ? "true" : "false"));
    this.name.textContent = tile ? tile.dataset.name : this.pickLabel;
    if (tile) {
      this.price.textContent = "+ " + tile.dataset.price;
      if (this.confirmPrice) this.confirmPrice.textContent = tile.dataset.price;
    }
    this.roving();
  }

  // Only the chosen tile (or the first in stock) is in the Tab order.
  roving() {
    const focusable = this.picked || this.inStock()[0];
    this.tiles.forEach((t) => (t.tabIndex = t === focusable ? 0 : -1));
  }

  onKey(event, tile) {
    const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
    if (!(event.key in keys)) return;
    event.preventDefault();
    const list = this.inStock();
    const next = list[(list.indexOf(tile) + keys[event.key] + list.length) % list.length];
    if (next) {
      this.pick(next);
      next.focus();
    }
  }

  setBusy(busy) {
    if (this.confirm) this.confirm.disabled = busy;
    this.tiles.forEach((t) => (t.disabled = busy || !!t.dataset.out));
  }

  // Cart: adds one of the chosen type; the drawer then re-renders (without this card when it worked). Refused: the cart
  // has re-rendered by the time the promise settles, so the reason goes on the product's line, which survives that.
  addToCart(tile) {
    const owner = this.closest("cart-drawer") || this.closest("cart-page");
    const lineKey = this.closest("cartline-item")?.dataset.key;
    const fallback = this.dataset.fallback;
    this.setBusy(true);
    owner.addItem(tile.dataset.addonVariant, 1).then((result) => {
      if (!result.ok) owner.lineMessage(lineKey, result.message || fallback);
      owner.querySelector('cartline-item[data-key="' + lineKey + '"]')?.focus({ preventScroll: true });
    });
  }

  // The product page's add to cart: the variant to add with the product, or null.
  selectedVariant() {
    return this.picked ? this.picked.dataset.addonVariant : null;
  }
}

customElements.define("fixed-addon", FixedAddon);
